import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { PeoInfoFragment } from 'src/api';
import { Button } from 'src/components/common';
import { TableThemes, TableTopAction } from 'src/components/table';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';
import { PaginationContextValue } from 'src/providers/PaginationProvider';

import { PEOS_TABLE_COLUMNS, PEOS_TABLE_COLUMNS_WITHOUT_AVATAR } from './constants';
import { PeosInnerTable } from './PeosInnerTable';

type PeosTablePeoPayrollProviderProps = {
  peosCount: number;
  peosList: PeoInfoFragment[];
  loading: boolean;
  isDetail?: boolean;
  onRefresh?: () => Promise<void>;
  pagination: PaginationContextValue;
};

export const PeosTablePeoPayrollProvider: React.FC<PeosTablePeoPayrollProviderProps> = ({
  peosCount,
  peosList,
  loading,
  onRefresh,
  isDetail = false,
  pagination,
}) => {
  const { openModal } = useModal();

  const topActions = React.useMemo(
    (): Array<TableTopAction> => [
      {
        actionName: 'Add',
        icon: <AddIcon />,
        show: true,
        onAction: () => {
          openModal(ModalId.InvitePeoByPeoPp);
        },
        render() {
          return (
            <Button
              variant="contained"
              startIcon={this.icon}
              loading={loading}
              disabled={loading}
              onClick={this.onAction}
            >
              New
            </Button>
          );
        },
      },
    ],
    [loading, openModal],
  );

  return (
    <PeosInnerTable
      peosList={peosList}
      peosCount={peosCount}
      loading={loading}
      columns={isDetail ? PEOS_TABLE_COLUMNS_WITHOUT_AVATAR : PEOS_TABLE_COLUMNS}
      topActions={topActions}
      isDetail={isDetail}
      tableTheme={isDetail ? TableThemes.withBorder : TableThemes.default}
      pagination={pagination}
      onRefresh={onRefresh}
    />
  );
};
